// extracted by mini-css-extract-plugin
export default {"wrapper_input":"styles_wrapper_input__3cUxp","input":"styles_input__8rVO9","buttonDeleteSearch":"styles_buttonDeleteSearch__5Tpk3"};